import { ModalService } from '@capsicum/common-web';
import {
	useV2FTSupportedDestinationsWarningModal as useSharedV2FTSupportedDestinationsWarningModal,
	type UseV2FTSupportedDestinationsWarningModalProps
} from '@capsicum/features/nc-wallet/shared';
import { useCallback } from 'react';

import { V2FTSupportedDestinationsWarningModalContent } from '../ui/v2ft-supported-destinations-warning-modal/V2FTSupportedDestinationsWarningModalContent';
import { V2FTSupportedDestinationsWarningModalFooter } from '../ui/v2ft-supported-destinations-warning-modal/V2FTSupportedDestinationsWarningModalFooter';

export const useV2FTSupportedDestinationsWarningModal = ({
	asset,
	onSubmit
}: UseV2FTSupportedDestinationsWarningModalProps) =>
	useSharedV2FTSupportedDestinationsWarningModal({
		asset,
		onSubmit,
		showModal: useCallback(
			({ exchanges, hash, wallets }) =>
				asset &&
				ModalService.addModal({
					isClosable: false,
					renderComponent: () => (
						<V2FTSupportedDestinationsWarningModalContent
							asset={asset}
							exchanges={exchanges}
							wallets={wallets}
						/>
					),
					renderFooter: ({ close }) => (
						<V2FTSupportedDestinationsWarningModalFooter
							asset={asset}
							close={close}
							hash={hash}
							onSubmit={onSubmit}
						/>
					)
				}),
			[asset, onSubmit]
		)
	});
